import { all, call, put, takeLatest, debounce } from 'redux-saga/effects'
import { notification } from 'antd'
import { push } from 'connected-react-router'
import {
  FETCH_THEME,
  ThemeActions,
  START_THEME_VALIDATION,
  START_SAVING_THEME,
  FETCH_THEME_INFO,
  START_DELETING_THEME
} from './actions'
import { fetchThemes, validateTheme, saveTheme, fetchThemeInfo, deleteTheme, updateTheme } from '../../api/theme'
import { ThemeValidationResult, Theme } from './types'
import { THEMES } from '../../routes'

const VALIDATION_DEBOUNCE_TIME = 250

export function* loadThemes() {
  try {
    const { data } = yield call(fetchThemes)
    yield put(ThemeActions.fetchThemessSuccess(data))
  } catch (err) {
    // eslint-disable-next-line no-console
    yield console.log(err)
  }
}

export function* validateNewTheme(action: ReturnType<typeof ThemeActions.startThemeValidation>) {
  const { theme } = action.payload
  const { data }: { data: ThemeValidationResult } = yield call(validateTheme, theme)
  yield put(ThemeActions.updateThemeValidation(data))
}

export function* savingTheme(action: ReturnType<typeof ThemeActions.startSavingTheme>) {
  const { theme } = action.payload
  let data: Theme | null = null
  if (theme.id) {
    const response = yield call(updateTheme, theme.id, theme)
    data = response.data
  } else {
    const response = yield call(saveTheme, theme)
    data = response.data
  }
  if (data) {
    yield put(ThemeActions.savingThemeSuccess(data))
    yield put(ThemeActions.resetNewTheme())
    yield put(push(THEMES))
  }
}

export function* fetchTheme(action: ReturnType<typeof ThemeActions.fetchThemeInfo>) {
  try {
    const { data }: { data: Theme } = yield call(fetchThemeInfo, action.payload)
    yield put(ThemeActions.fetchThemeInfoSuccess(data))
  } catch (err) {
    yield put(ThemeActions.fetchThemeInfoFail())
    yield put(push(THEMES))
  }
}

export function* deletingTheme(action: ReturnType<typeof ThemeActions.startDeletingTheme>) {
  try {
    const { data }: { data: { success: boolean } } = yield call(deleteTheme, action.payload)
    if (data.success) {
      notification.success({
        message: 'Eliminazione Theme',
        description: 'Tema eliminato con successo'
      })
    } else {
      notification.error({
        message: 'Eliminazione Theme',
        description: 'Non è stato possibile eliminare il Tema'
      })
    }
    yield call(loadThemes)
  } catch (error) {
    // error
  }
}

export function* rootSaga() {
  yield all([
    takeLatest(FETCH_THEME, loadThemes),
    takeLatest(START_SAVING_THEME, savingTheme),
    takeLatest(START_DELETING_THEME, deletingTheme),
    takeLatest(FETCH_THEME_INFO, fetchTheme),
    debounce(VALIDATION_DEBOUNCE_TIME, START_THEME_VALIDATION, validateNewTheme)
  ])
}
